exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".drop-zone-drop-zone-1O909WkVmwr{position:relative}.drop-zone-input-4Cm7mawJmwr{width:0.1px;height:0.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"drop-zone": "drop-zone-drop-zone-1O909WkVmwr",
	"dropZone": "drop-zone-drop-zone-1O909WkVmwr",
	"input": "drop-zone-input-4Cm7mawJmwr"
};